/**
 * Tracks when a verification email was last sent to a given address so the UI can:
 *  - avoid asking Firebase to resend if we've already sent recently (rate-limit protection)
 *  - show a cooldown message on the resend button
 *
 * Per-email, localStorage-backed. One key per email address.
 */
const KEY_PREFIX = 'deallock.verification_email_sent.';
export function recordVerificationEmailSent(email) {
    if (!email)
        return;
    try {
        localStorage.setItem(`${KEY_PREFIX}${email}`, String(Date.now()));
    }
    catch {
        // localStorage may be unavailable (private mode quota etc.) — non-fatal.
    }
}
export function readLastVerificationEmailSentAt(email) {
    if (!email)
        return null;
    try {
        const raw = localStorage.getItem(`${KEY_PREFIX}${email}`);
        if (!raw)
            return null;
        const parsed = Number(raw);
        return Number.isFinite(parsed) ? parsed : null;
    }
    catch {
        return null;
    }
}
export function clearVerificationEmailSent(email) {
    if (!email)
        return;
    try {
        localStorage.removeItem(`${KEY_PREFIX}${email}`);
    }
    catch {
        // non-fatal
    }
}
